module.exports = __webpack_public_path__ + "../resources/img/ic_re_info.6911d0c7.svg";